import { styled } from '@mui/material'

export const ContactName = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  background: '#FAFAFA',
  padding: '6px 8px',
  boxSizing: 'border-box',
  borderRadius: '6px'
}))

export const ContactPhoneAndNumber = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  background: '#FAFAFA',
  padding: '6px 8px',
  borderRadius: '6px'
}))
